import toast from "react-hot-toast";
import { baseUrl } from "./baseUrl";

export async function suspendCampaign(
  id: string,
  reason?: string
): Promise<void> {
  const token = sessionStorage.getItem("admin_token");
  try {
    const res = await fetch(
      `${baseUrl}/admin/campaigns/${encodeURIComponent(id)}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          // status: "suspended",
          reason: reason ?? "",
        }),
      }
    );

    if (!res.ok) {
      // try to pull out a structured error
      const err = await res.json().catch(() => null);
      const msg = err?.message?.toLowerCase?.() ?? "";
      // handle auth errors
      if (
        msg === "invalid token" ||
        msg === "jwt malformed" ||
        msg === "jwt expired"
      ) {
        sessionStorage.removeItem("admin_token");
        toast.error("Session expired, please sign in again.");
        window.location.href = "/auth/sign-in";
        return Promise.reject(new Error("Unauthorized"));
      }
      throw new Error(err?.message ?? `HTTP ${res.status}`);
    }

    toast.success("Campaign suspended successfully");
  } catch (error) {
    console.error("Error suspending campaign:", (error as Error).message);
    toast.error(`Campaign suspension failed: ${(error as Error).message}`);
    throw error;
  }
}
